module.exports = __webpack_public_path__ + "img/lb-wordle.05f6f5c9.svg";